import React from 'react'
import {Route, IndexRoute} from 'react-router'

import AggreatedAttributionView from 'views/AggreatedAttributionView'
import AggreatedAttributionMenu from 'views/AggreatedAttributionView/menu'

export default trackRoute => {
  return (
    <Route path='aggreated-attribution-explorer' title='Aggreated Attribution'>
      <IndexRoute
        title='Aggregated Attribution Explorer'
        components={{main: AggreatedAttributionView, menu: AggreatedAttributionMenu}}
        onEnter={trackRoute('aggreated-attribution-explorer')}
      />
    </Route>
  )
}



// WEBPACK FOOTER //
// ./client/routes/aggrAttribution.js